import axios from 'axios';
import { API_URL, API_KEY } from '../config';
import { getLevel } from './level';

// Créer une instance axios configurée
const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Intercepteur de requête : ajoute automatiquement la clé API dans les headers
apiClient.interceptors.request.use(
    (config) => {
        // Ajouter la clé API si elle est configurée
        if (API_KEY) {
            config.headers['x-api-key'] = API_KEY;
        }
        // Cibler le niveau de données sélectionné (level 1 = défaut backend, rien à envoyer)
        if (getLevel() === 2) {
            config.params = { ...(config.params || {}), level: 2 };
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Intercepteur de réponse : gère les erreurs d'authentification
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Si erreur 401 (non autorisé), la clé API est probablement invalide
        if (error.response?.status === 401) {
            console.error('Erreur d\'authentification : Clé API invalide ou manquante');
            // Vous pouvez ajouter ici une redirection vers une page de login ou afficher un message
        }
        return Promise.reject(error);
    }
);

export default apiClient;

